import React from "react";
import { NativeSelect } from "@mui/material";
import { PropTypes } from 'prop-types';

// Parametros props
//open: si se ve o no el mensaje 
//name: Nombre del componente (Identificador)
//items: Opciones que puedes elegir
//empty: Si necesita un opción vacia
//emptylabel: Etiqueta sin selección
//placeholder: Mensaje previo antes de seleccionar un item
//handleChange: Evento para seleccionar item

DropDownList.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  empty: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  helperText: PropTypes.string,
};

DropDownList.defaultProps = {  
  id:'Custom',
  name: "Custom",
  items: [],
  empty: true,
  placeholder: '',
  onChange: ()=>{ console.log("Se ha seleccionado un item")},
  helperText: '',
  default: '',
  valor: 'value'
}  

function DropDownList (props) {
    return (

        <NativeSelect style={{width: '100%'}} disabled={props.disabled} onChange={props.onChange} value={props.default}>
            {props.items.map((item, index) => {
                return (
                    <option key={index} value={item[props.valor]}>{item[props.valor]}</option>
                )
            })}
        </NativeSelect>


        //<Select options={props.items} />

        // <select className="dropdown-list" value={props.default}>
        //     {props.items.map((option, index) => (
        //         <option  value={option.value}>
        //             {option.value}
        //         </option>
        //     ))}
        // </select>

        // <div>
        //     <FormControl name={props.name} style={{width: '100%' }} >
        //         <InputLabel id={props.id}>{props.value!== undefined ? '' : props.placeholder}</InputLabel>
        //         <Select style={{textAlign: 'left'}} defaultValue={props.default} labelId={props.name} id={props.id} name={props.name} onChange={props.onChange} value={props.value} MenuProps={{disableScrollLock: false}}>
        //             {
        //                 props.items.map((item, index) =>  
        //                     <MenuItem id={index} name={index} value={item.value} key={item.id}>{item.value}</MenuItem>
        //                 )
        //             }
        //         </Select>
        //         <FormHelperText>{props.helperText}</FormHelperText>
        //     </FormControl>
        // </div>
    );
}

export default React.memo(DropDownList);